import { AccredibleCookiesServiceModule } from '@accredible-frontend-v2/services/cookies';
import { NgModule } from '@angular/core';
import { AccredibleAccountsRedirectionService } from './accounts-redirection.service';

@NgModule({
  imports: [AccredibleCookiesServiceModule],
  providers: [AccredibleAccountsRedirectionService],
})
export class AccredibleAccountsRedirectionServiceModule {}
